import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { CYAN, YELLOW, GREEN } from '../../HOME/const';
import * as f from '../logic';

const Scoreboard = props => {
  const { stats, size, steps } = props;
  const { plays, aveScore, bestScore, grade, score } = f.getMoreStats(stats, size, steps);

  return (
    <div className="tt-scoreboard">
      <span style={{ gridArea: '1/1', color: YELLOW }}>{plays || 0}</span>
      <span style={{ gridArea: '2/1', marginTop: '-1px' }}>plays</span>
      <span style={{ gridArea: '1/2', color: GREEN }}>{aveScore || 0}</span>
      <span style={{ gridArea: '2/2', marginTop: '-1px' }}>ave. score</span>
      <span style={{ gridArea: '1/3', color: GREEN }}>{bestScore || 0}</span>
      <span style={{ gridArea: '2/3', marginTop: '-1px' }}>best score</span>
      <span className="tt-quartz" style={{ gridArea: '3/1', color: CYAN }}>
        {steps || 0}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/1' }}>
        swaps
      </span>
      <span className="tt-quartz" style={{ color: YELLOW }}>
        {grade}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/2' }}>
        grade
      </span>
      <span className="tt-quartz" style={{ gridArea: '3/3', color: GREEN }}>
        {score}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/3' }}>
        score
      </span>
    </div>
  );
};

function mapStateToProps({ sm, common }) {
  return { ...sm, ...common };
}

export default connect(
  mapStateToProps,
  {}
)(Scoreboard);
